import { doc, runTransaction } from "firebase/firestore";
import { db } from "./firebase";

function pad(n, width = 5) {
  const s = String(n);
  return s.length >= width ? s : "0".repeat(width - s.length) + s;
}

export default async function allocateQuoteNumber(prefix = "EV") {
  const counterRef = doc(db, "counters", "quotes");

  const quoteNumber = await runTransaction(db, async (tx) => {
    const snap = await tx.get(counterRef);

    if (!snap.exists()) {
      tx.set(counterRef, { next: 2 });
      return `${prefix}-${pad(1)}`;
    }

    const data = snap.data();
    const next = Number(data.next || 1);

    tx.update(counterRef, { next: next + 1 });

    return `${prefix}-${pad(next)}`;
  });

  return quoteNumber;
}